"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : new P(function (resolve) {
        resolve(result.value);
      }).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
    label: 0,
    sent: function sent() {
      if (t[0] & 1) throw t[1];
      return t[1];
    },
    trys: [],
    ops: []
  },
      f,
      y,
      t,
      g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;

  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }

  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");

    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];

        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;

          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };

          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;

          case 7:
            op = _.ops.pop();

            _.trys.pop();

            continue;

          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }

            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }

            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }

            if (t && _.label < t[2]) {
              _.label = t[2];

              _.ops.push(op);

              break;
            }

            if (t[2]) _.ops.pop();

            _.trys.pop();

            continue;
        }

        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }

    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

var react_redux_1 = require("react-redux");

var wallets_1 = require("../../wallets");

var __1 = require("../..");

var wallet_1 = require("../../actions/wallet");

var Select_1 = __importDefault(require("./Select"));

var bignumber_js_1 = require("bignumber.js");

var react_paginate_1 = __importDefault(require("react-paginate"));

var NotSupport_1 = __importDefault(require("./NotSupport"));

var mapStateToProps = function mapStateToProps(state) {
  var account = __1.getAccount(state, wallets_1.Ledger.TYPE);

  return {
    wallet: account ? account.get("wallet") : null,
    isLocked: account ? account.get("isLocked") : true,
    ledgerConnecting: state.WalletReducer.get("ledgerConnecting"),
    walletTranslations: state.WalletReducer.get("walletTranslations")
  };
};

var batchCount = 3;

var LedgerConnector = function (_super) {
  __extends(LedgerConnector, _super);

  function LedgerConnector(props) {
    var _this = _super.call(this, props) || this;

    _this.handleChangeCustomizedPath = function (event) {
      var path = event.target.value;
      var realPath = "" + wallets_1.Ledger.PREFIX_ETHEREUM_PATH + path;

      _this.setState({
        realPath: realPath
      });
    };

    _this.selectPath = function (selectedOption) {
      var pathType = selectedOption.value;

      if (pathType !== wallets_1.Ledger.CUSTOMIZAION_PATH) {
        _this.setState({
          realPath: pathType
        });
      }

      _this.setState({
        pathType: pathType
      });
    };

    _this.gotoPageSubmit = function (event) {
      event.preventDefault();
      var gotoPageInputValue = _this.state.gotoPageInputValue;
      var pageNumber = Number(gotoPageInputValue) - 1;

      _this.setState({
        currentPage: pageNumber,
        index: pageNumber * batchCount
      });
    };

    _this.changePage = function (_a) {
      var selected = _a.selected;

      _this.setState({
        currentPage: selected,
        index: selected * batchCount
      });
    };

    _this.state = {
      loading: false,
      pathType: wallets_1.Ledger.getPathType(wallets_1.Ledger.currentBasePath),
      realPath: wallets_1.Ledger.currentBasePath,
      index: 0,
      currentPage: 0,
      addresses: {},
      balances: {},
      currentAddress: null,
      gotoPageInputValue: 1
    };
    return _this;
  }

  LedgerConnector.prototype.componentDidMount = function () {
    var wallet = this.props.wallet;
    var addresses = this.state.addresses;

    if (wallet && wallet.connected) {
      this.loadAddresses();
    }

    if (addresses) {
      this.loadBalances();
    }
  };

  LedgerConnector.prototype.componentDidUpdate = function (prevProps, prevState) {
    var wallet = this.props.wallet;
    var _a = this.state,
        addresses = _a.addresses,
        index = _a.index,
        realPath = _a.realPath,
        pathType = _a.pathType;

    if (wallet && wallet.connected && (Object.values(addresses).length === 0 || wallet !== prevProps.wallet || index !== prevState.index || pathType !== wallets_1.Ledger.CUSTOMIZAION_PATH && realPath !== prevState.realPath)) {
      this.loadAddresses();
    }

    if (addresses !== prevState.addresses) {
      this.loadBalances();
    }
  };

  LedgerConnector.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        isLocked = _a.isLocked,
        ledgerConnecting = _a.ledgerConnecting,
        walletTranslations = _a.walletTranslations;
    return React.createElement("div", {
      className: "HydroSDK-ledger"
    }, this.renderContent(), isLocked && React.createElement("button", {
      className: "HydroSDK-button HydroSDK-submitButton HydroSDK-featureButton",
      disabled: ledgerConnecting,
      onClick: function onClick() {
        return _this.connectLedger();
      }
    }, ledgerConnecting ? React.createElement("i", {
      className: "HydroSDK-fa fa fa-spinner fa-spin"
    }) : null, " ", walletTranslations.connectLedger));
  };

  LedgerConnector.prototype.renderContent = function () {
    var _a = this.props,
        isLocked = _a.isLocked,
        walletTranslations = _a.walletTranslations;

    if (isLocked) {
      return React.createElement(NotSupport_1.default, {
        iconName: "ledger",
        title: walletTranslations.connectLedger,
        desc: walletTranslations.connectLedgerDesc
      });
    }

    var _b = this.state,
        loading = _b.loading,
        currentAddress = _b.currentAddress,
        pathType = _b.pathType;
    var addressOptions = this.getAddressOptions();
    var pathOptions = this.getPathOptions();
    return React.createElement(React.Fragment, null, React.createElement("div", {
      className: "HydroSDK-fieldGroup"
    }, React.createElement("div", {
      className: "HydroSDK-label"
    }, walletTranslations.selectPath), React.createElement(Select_1.default, {
      options: pathOptions,
      selected: pathType,
      onSelect: this.selectPath
    })), pathType === wallets_1.Ledger.CUSTOMIZAION_PATH && this.renderCustomizedPath(), React.createElement("div", {
      className: "HydroSDK-fieldGroup"
    }, React.createElement("div", {
      className: "HydroSDK-label"
    }, walletTranslations.selectAddress), React.createElement(Select_1.default, {
      options: addressOptions,
      selected: !loading && currentAddress,
      noCaret: addressOptions.length === 0,
      disabled: addressOptions.length === 0,
      footer: this.renderFooter(),
      blank: loading || addressOptions.length === 0 ? React.createElement("i", {
        className: "fa fa-spinner fa-spin"
      }) : walletTranslations.pleaseSelectAddress
    })));
  };

  LedgerConnector.prototype.renderCustomizedPath = function () {
    var _this = this;

    var _a = this.state,
        realPath = _a.realPath,
        loading = _a.loading;
    var walletTranslations = this.props.walletTranslations;
    return React.createElement("div", {
      className: "HydroSDK-fieldGroup"
    }, React.createElement("div", {
      className: "HydroSDK-label"
    }, walletTranslations.inputPath), React.createElement("div", {
      className: "HydroSDK-customizationInputGroup"
    }, React.createElement("span", null, wallets_1.Ledger.PREFIX_ETHEREUM_PATH), React.createElement("input", {
      className: "HydroSDK-input",
      placeholder: "0'/0",
      value: realPath.replace(wallets_1.Ledger.PREFIX_ETHEREUM_PATH, ""),
      onChange: this.handleChangeCustomizedPath
    }), React.createElement("button", {
      className: "HydroSDK-button HydroSDK-featureButton",
      disabled: loading,
      onClick: function onClick() {
        return _this.loadAddresses();
      }
    }, loading ? React.createElement("i", {
      className: "HydroSDK-fa fa fa-spinner fa-spin"
    }) : null, " Load Accounts")));
  };

  LedgerConnector.prototype.getPathOptions = function () {
    return [{
      value: wallets_1.Ledger.PATH_TYPE.LEDGER_LIVE,
      component: React.createElement("div", {
        className: "HydroSDK-pathItem"
      }, "Ledger Live")
    }, {
      value: wallets_1.Ledger.PATH_TYPE.LEGACY,
      component: React.createElement("div", {
        className: "HydroSDK-pathItem"
      }, "Legacy (MEW / MyCrypto)")
    }, {
      value: wallets_1.Ledger.CUSTOMIZAION_PATH,
      component: React.createElement("div", {
        className: "HydroSDK-pathItem"
      }, "Customization")
    }];
  };

  LedgerConnector.prototype.getAddressOptions = function () {
    var _this = this;

    var _a = this.state,
        addresses = _a.addresses,
        balances = _a.balances;
    var addressOptions = [];
    Object.keys(addresses).map(function (path) {
      var address = addresses[path];
      var balance = balances[address];
      addressOptions.push({
        value: address,
        component: React.createElement("div", {
          className: "HydroSDK-address-option"
        }, React.createElement("span", null, React.createElement("i", {
          className: "HydroSDK-fa fa fa-check"
        }), wallets_1.truncateAddress(address)), React.createElement("span", null, balance ? balance.div("1000000000000000000").toFixed(5) : React.createElement("i", {
          className: "HydroSDK-fa fa fa-spinner fa-spin"
        }), " ", "ETH")),
        onSelect: function onSelect() {
          _this.selectAccount(address, path);
        }
      });
    });
    return addressOptions;
  };

  LedgerConnector.prototype.renderFooter = function () {
    var _this = this;

    var _a = this.state,
        currentPage = _a.currentPage,
        gotoPageInputValue = _a.gotoPageInputValue;
    return React.createElement(React.Fragment, null, React.createElement(react_paginate_1.default, {
      key: currentPage,
      initialPage: currentPage,
      previousLabel: "<",
      nextLabel: ">",
      breakLabel: "...",
      pageCount: 10000,
      marginPagesDisplayed: 0,
      pageRangeDisplayed: 2,
      onPageChange: this.changePage,
      containerClassName: "HydroSDK-pagination",
      breakClassName: "break-me",
      activeClassName: "active"
    }), React.createElement("div", {
      className: "HydroSDK-paginationGotoPage"
    }, "Go to page", React.createElement("form", {
      onSubmit: this.gotoPageSubmit
    }, React.createElement("input", {
      className: "HydroSDK-input",
      type: "number",
      min: "1",
      step: "1",
      value: gotoPageInputValue,
      onChange: function onChange(event) {
        return _this.setState({
          gotoPageInputValue: parseInt(event.target.value, 10)
        });
      }
    }))));
  };

  LedgerConnector.prototype.loadAddresses = function () {
    return __awaiter(this, void 0, void 0, function () {
      var wallet, _a, realPath, index, addresses;

      return __generator(this, function (_b) {
        switch (_b.label) {
          case 0:
            wallet = this.props.wallet;

            if (!wallet) {
              return [2];
            }

            _a = this.state, realPath = _a.realPath, index = _a.index;
            this.setState({
              loading: true
            });
            return [4, wallet.getAddressesWithPath(realPath, index, batchCount)];

          case 1:
            addresses = _b.sent();
            this.setState({
              addresses: addresses,
              loading: false
            });
            return [2];
        }
      });
    });
  };

  LedgerConnector.prototype.selectAccount = function (address, path) {
    var parts = path.split("/");
    var pathType = parts.slice(0, parts.length - 1).join("/");
    var index = parseInt(parts[parts.length - 1], 10);
    this.props.dispatch(wallet_1.selectAccount(wallets_1.Ledger.TYPE, wallets_1.Ledger.TYPE));
    wallets_1.Ledger.setPath(pathType, index);
    this.setState({
      currentAddress: address
    });
  };

  LedgerConnector.prototype.connectLedger = function () {
    return __awaiter(this, void 0, void 0, function () {
      var dispatch, pathType;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            dispatch = this.props.dispatch;
            dispatch(wallet_1.selectAccount(wallets_1.Ledger.TYPE, wallets_1.Ledger.TYPE));
            return [4, dispatch(wallet_1.loadLedger())];

          case 1:
            _a.sent();

            pathType = wallets_1.Ledger.getPathType(wallets_1.Ledger.currentBasePath);
            this.setState({
              pathType: pathType,
              realPath: wallets_1.Ledger.currentBasePath
            });
            return [2];
        }
      });
    });
  };

  LedgerConnector.prototype.loadBalances = function () {
    var _this = this;

    var addresses = this.state.addresses;
    Object.keys(addresses).map(function (path) {
      return __awaiter(_this, void 0, void 0, function () {
        var balances, address, balance;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              balances = this.state.balances;
              address = addresses[path];
              return [4, wallets_1.getBalance(address)];

            case 1:
              balance = _a.sent();
              balances[address] = new bignumber_js_1.BigNumber(String(balance));
              this.setState({
                balances: balances
              });
              this.forceUpdate();
              return [2];
          }
        });
      });
    });
  };

  return LedgerConnector;
}(React.PureComponent);

exports.default = react_redux_1.connect(mapStateToProps)(LedgerConnector);